module.exports = __webpack_public_path__ + "img/mcapp.5abfbbfb.png";